import { Section } from '@/components/ui/layouts/sections/Section';
import { cx } from '@mage-ui/styled-system/css';
import {
  button,
  textContainer,
  textStyles,
} from '@mage-ui/styled-system/recipes';
import Link from 'next/link';
import { isExternalLink } from 'utils/isExternalLink';

export const TextBlock = ({ data }) => {
  const ctaSlug = data?.fields?.cta_slug;
  const ctaText = data?.fields?.cta_text;

  const isExternal = isExternalLink(ctaSlug);

  return (
    <Section
      heading={{
        title: data?.fields?.title || null,
        intro: data?.fields?.intro || null,
        meta: data?.fields?.meta || null,
        epi: data?.fields?.epi || null,
      }}
      footer={
        ctaText && ctaSlug ? (
          <Link
            href={ctaSlug}
            className={button()}
            {...(isExternal && {
              target: '_blank',
              rel: 'noopener noreferrer',
            })}
          >
            {ctaText}
          </Link>
        ) : null
      }
    >
      <div
        className={cx(textContainer(), textStyles())}
        dangerouslySetInnerHTML={{ __html: data?.fields?.text || '' }}
      />
    </Section>
  );
};
